import {
  IMPORT_USER_DATA,
  IMPORT_USER_DATA_SUCCESS,
  IMPORT_USER_DATA_ERROR,
  IMPORT_ROUTES,
  IMPORT_ROUTES_SUCCESS,
  IMPORT_ROUTES_ERROR,
  UPLOAD_ROUTES_FILE,
  UPLOAD_USERS_FILE,
  UPLOAD_USER_FILE_SUCCESS,
  UPLOAD_ROUTES_FILE_SUCCESS,
  EXTRACT_USER_DATA,
  EXTRACT_USER_DATA_SUCCESS,
  EXTRACT_USER_DATA_ERROR,
  EXTRACT_ROUTES,
  EXTRACT_ROUTES_SUCCESS,
  EXTRACT_ROUTES_ERROR,
  EXPORT_USER_DATA,
  EXPORT_USER_DATA_SUCCESS,
  EXPORT_USER_DATA_ERROR,
  EXPORT_ROUTES,
  EXPORT_ROUTES_SUCCESS,
  EXPORT_ROUTES_ERROR,
  IMPORT_ECA_EVENTS,
  IMPORT_ECA_EVENTS_SUCCESS,
  IMPORT_ECA_EVENTS_ERROR,
  UPLOAD_ECA_EVENTS_FILE,
  UPLOAD_ECA_EVENTS_FILE_SUCCESS,
  EXTRACT_ECA_EVENTS,
  EXTRACT_ECA_EVENTS_SUCCESS,
  EXTRACT_ECA_EVENTS_ERROR,
  EXPORT_ECA_EVENTS,
  EXPORT_ECA_EVENTS_SUCCESS,
  EXPORT_ECA_EVENTS_ERROR,
  GET_ROUTES_EXPORT_FORMATS,
  GET_ROUTES_EXPORT_FORMATS_SUCCESS,
  GET_ROUTES_EXPORT_FORMATS_ERROR,
} from 'constants/ActionTypes';

export const importUserDataRequest = () => ({
  type: IMPORT_USER_DATA,
});

export const importUserDataSuccess = () => ({
  type: IMPORT_USER_DATA_SUCCESS,
});

export const importUserDataError = () => ({
  type: IMPORT_USER_DATA_ERROR,
});

export const importRoutesRequest = () => ({
  type: IMPORT_ROUTES,
});

export const importRoutesSuccess = () => ({
  type: IMPORT_ROUTES_SUCCESS,
});

export const importRoutesError = () => ({
  type: IMPORT_ROUTES_ERROR,
});

export const importEcaEventsRequest = () => ({
  type: IMPORT_ECA_EVENTS,
});

export const importEcaEventsSuccess = () => ({
  type: IMPORT_ECA_EVENTS_SUCCESS,
});

export const importEcaEventsError = () => ({
  type: IMPORT_ECA_EVENTS_ERROR,
});

export const uploadUsersFile = file => ({
  type: UPLOAD_USERS_FILE,
  payload: file,
});

export const uploadUsersFileSuccess = () => ({
  type: UPLOAD_USER_FILE_SUCCESS,
});

export const uploadRoutesFile = file => ({
  type: UPLOAD_ROUTES_FILE,
  payload: file,
});

export const uploadRoutesFileSuccess = () => ({
  type: UPLOAD_ROUTES_FILE_SUCCESS,
});

export const uploadEcaEventsFile = file => ({
  type: UPLOAD_ECA_EVENTS_FILE,
  payload: file,
});

export const uploadEcaEventsFileSuccess = () => ({
  type: UPLOAD_ECA_EVENTS_FILE_SUCCESS,
});

export const extractUserDataRequest = () => ({
  type: EXTRACT_USER_DATA,
});

export const extractUserDataSuccess = () => ({
  type: EXTRACT_USER_DATA_SUCCESS,
});

export const extractUserDataError = () => ({
  type: EXTRACT_USER_DATA_ERROR,
});

export const extractRoutesRequest = format => ({
  type: EXTRACT_ROUTES,
  payload: format,
});

export const extractRoutesSuccess = () => ({
  type: EXTRACT_ROUTES_SUCCESS,
});

export const extractRoutesError = () => ({
  type: EXTRACT_ROUTES_ERROR,
});

export const extractEcaEventsRequest = () => ({
  type: EXTRACT_ECA_EVENTS,
});

export const extractEcaEventsSuccess = () => ({
  type: EXTRACT_ECA_EVENTS_SUCCESS,
});

export const extractEcaEventsError = () => ({
  type: EXTRACT_ECA_EVENTS_ERROR,
});

export const exportUserDataRequest = () => ({
  type: EXPORT_USER_DATA,
});

export const exportUserDataSuccess = () => ({
  type: EXPORT_USER_DATA_SUCCESS,
});

export const exportUserDataError = () => ({
  type: EXPORT_USER_DATA_ERROR,
});

export const exportRoutesRequest = format => ({
  type: EXPORT_ROUTES,
  payload: format,
});

export const exportRoutesSuccess = () => ({
  type: EXPORT_ROUTES_SUCCESS,
});

export const exportRoutesError = () => ({
  type: EXPORT_ROUTES_ERROR,
});

export const getRoutesExportFormatsRequest = () => ({
  type: GET_ROUTES_EXPORT_FORMATS,
});

export const getRoutesExportFormatsSuccess = formats => ({
  type: GET_ROUTES_EXPORT_FORMATS_SUCCESS,
  payload: formats,
});

export const getRoutesExportFormatsError = () => ({
  type: GET_ROUTES_EXPORT_FORMATS_ERROR,
});

export const exportEcaEventsRequest = () => ({
  type: EXPORT_ECA_EVENTS,
});

export const exportEcaEventsSuccess = () => ({
  type: EXPORT_ECA_EVENTS_SUCCESS,
});

export const exportEcaEventsError = () => ({
  type: EXPORT_ECA_EVENTS_ERROR,
});
